import { ActionReducerMap, createFeatureSelector, createSelector, MetaReducer } from '@ngrx/store';
import { ApplicationEffects, applicationReducer, ApplicationState } from './application';

export interface State {
    applicationReducer: ApplicationState;
}

export const reducers: ActionReducerMap<State> = {
    applicationReducer
};

export const effects: any[] = [ApplicationEffects];

export const getApplicationState = createFeatureSelector<ApplicationState>('applicationReducer');

export const getProblemTypeMenu = createSelector(
    getApplicationState,
    (state: ApplicationState) => state.newProblemMenuItems
);

export const getSelectedProblemMenuItem = createSelector(
    getApplicationState,
    (state: ApplicationState) => state.selectedProblemMenuItem
);

export const getFilteredProblemMenuItemCount = createSelector(
    getApplicationState,
    (state: ApplicationState) => state.filteredProblemMenuItemsCount
);

export const getCurrentStep = createSelector(
    getApplicationState,
    (state: ApplicationState) => state.currentStep
);

export const getProblemDetails = createSelector(
    getApplicationState,
    (state: ApplicationState) => state.problemDetails
);

export const getProblemPhotos = createSelector(
    getApplicationState,
    (state: ApplicationState) => state.problemPhotos
);

export const getContactInfo = createSelector(
    getApplicationState,
    (state: ApplicationState) => state.contactInfo
);

export const getSelectedCoordinates = createSelector(
    getApplicationState,
    (state: ApplicationState) => state.selectedLatLng
);

export const getProblemLocation = createSelector(
    getApplicationState,
    (state: ApplicationState) => state.problemLocation
);

export const getProblemQuestions = createSelector(
    getApplicationState,
    (state: ApplicationState) => state.problemQuestions
);

export const getNewProblemUniqueId = createSelector(
    getApplicationState,
    (state: ApplicationState) => state.newProblemUniqueId
);
